import Image from 'app/Components/Shared/Image/image';
import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import {
  PopupEnum,
  TransferAccountStep,
  simCardType,
  DwhActionType,
  DWHMessageText,
  DWHStatus,
  transferOption,
} from '../../Constant/Constant';
import {setCurrentPopUp, setCurrentStep, GetOrganizationPricePlan, transferBussinessCustomer} from '../../TransferOrganizationAccountSlice';
import BtnSubmitValidation from '../../../../Shared/Buttons/BtnSubmitValidation';
import OrgPricePlan from './OrgPricePlan';
import EpiPricePlan from './EpiPricePlan';
import {isMobile} from 'react-device-detect';
import {dwhGeneralReport} from '../../Reports/dwhReports';

const PlanSelection = (props) => {
  useEffect(() => {
    if (props.data.selectedTransferOption == transferOption.niud) {
      getOrganizationPricePlan();
    }
  }, []);
  const getOrganizationPricePlan = async () => {
    await props.GetOrganizationPricePlan();
  };

  const getSelectedBanAccountType = () => {
    props.data.banListForSelect.map((ban) => {
      if (ban == props.data.selectedBanNumber) {
        return ban.banAccountType;
      }
    });
  };

  const GoToNextStep = async () => {
    if (props.data.simCardType == simCardType.eSim) {
      props.setCurrentStep(TransferAccountStep.EsimConfirmation);
    } else {
      await props.transferBussinessCustomer();
      //DWH Report
      let isSim = props.data.simCardType == simCardType.sim;
      dwhGeneralReport({
        data: {...props.data, selectedHetPay: props.selectedHetPay, userDetails: props.userDetails},
        status: DWHStatus.Ongoing,
        messageText: isSim ? DWHMessageText.PackageSIMClicked : DWHMessageText.PackageESIMClick,
        actionType: isSim ? DwhActionType.ChoosePackagePageRegularSIM : DwhActionType.ChoosePackagePageESIM,
      });
    }
  };

  return (
    <div className='planSelection'>
      <div className='L_Title'>
        איזו חבילה לקשר <br />
        למספר הטלפון {props.data.selectedPhoneNumber}?{' '}
      </div>

      <OrgPricePlan />
      <EpiPricePlan />

      <div className='link'>
        <Image className='icon_link'
          src={props.serviceForm.serviceFormIsSign ? require('../../icons/check.svg') : require('../../icons/file.svg')} />
        <p className='text_link' onClick={() => props.setCurrentPopUp(PopupEnum.ServiceFormPopup)}>
          {' '}
          חתימה על גישה לשירותים{' '}
        </p>
      </div>

      <BtnSubmitValidation
        text={'ליצירת הזמנה והפעלת הקו'}
        disableReasonText={
          props.data.selectedPricePlan == null
            ? 'כדי להמשיך יש לבחור חבילה'
            : !props.serviceForm.serviceFormIsSign
            ? 'כדי להמשיך יש לחתום על טופס גישה לשירותים'
            : ''
        }
        onclick={() => {
          GoToNextStep();
        }}
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  data: state.TransferOrganizationAccount,
  selectedHetPay: state.portalsBlock.selectedHetPay,
  userDetails: state.authentication?.loginData?.userDetails,
  serviceForm: state.serviceAccessForm,
});

const mapDispatchToProps = {
  GetOrganizationPricePlan,
  setCurrentPopUp,
  setCurrentStep,
  transferBussinessCustomer,
};

export default connect(mapStateToProps, mapDispatchToProps)(PlanSelection);
